import React, { useContext } from 'react';
import UserContext from '../context/UserContext';
import { Redirect } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

const CheckOut = () => {
	const context = useContext(UserContext);
	const checkOut = () => {
		context.setPay(false);
		context.setPaid(false);
		context.cartItem.map((item) => {
			return (item.noItem = 1);
		});
		context.setCartItem([]);
		context.setTotal(0);
		context.setQuery('');
		context.setCart(false);
	};
	const payment = () => {
		toast('Successfully Paid🚀', { type: 'success' });
		toast('Purchased Successfully...🎉', { type: 'success' });
		context.setPaid(true);
	};
	if (!context.pay) return <Redirect to="/CartItems" />;
	if (context.paid) {
		return (
			<div className="paid__wrapper">
				<ToastContainer />

				<div className="paid__heading">
					<h3>Paid Successfully</h3>
				</div>
				<div className="paid__getBack">
					<button onClick={() => checkOut()} className="button__paid__goBack">
						◀Get Back
					</button>
				</div>
			</div>
		);
	}
	return (
		<div className="checkout__container">
			<ToastContainer />
			<div className="checkout__wrapper">
				<div className="checkout__heading">Your Final Cart 🛒</div>
				<div className="checkount__body__container">
					{context.cartItem.map((item) => {
						return (
							<div className="checkout__body" key={item.id}>
								<div className="checkout__itemName">
									<h6>{item.productName}</h6>
								</div>
								<div className="checkout__noItems">
									<h6>
										{item.productPrice} x {item.noItem}=
										{'$' + Number(item.productPrice) * Number(item.noItem)}
									</h6>
								</div>
							</div>
						);
					})}
				</div>
				<div className="checkout__totalAmount">
					<h6>Total Amount : ${context.total}</h6>
				</div>
				<div className="checkout__payNow">
					<button
						className="button_checkout__goBack"
						onClick={() => context.setPay(false)}
					>
						<h6>◀Go-Back</h6>
					</button>
					<button onClick={() => payment()} className="button_checkout__payNow">
						<h6>Pay Now</h6>
					</button>
				</div>
			</div>
		</div>
	);
};

export default CheckOut;
